import firebase from 'firebase/app'
import { put, takeEvery } from 'redux-saga/effects'

import { EVENT_LOGIN } from 'modules/firebase/events'
import { types as analyticsActionTypes } from './analytics.reducer'
import { types as userActionTypes } from 'logic/user/user.reducer'

function* processLoginSuccess() {
    firebase.analytics().logEvent(EVENT_LOGIN)
    yield put({ type: analyticsActionTypes.LOGIN_SUCCESS })

    firebase.analytics().setUserId(firebase.auth().currentUser.uid)
    yield put({ type: analyticsActionTypes.SET_USER_ID })
}

// watch login success
export function* watchLoginSuccess() {
    yield takeEvery(userActionTypes.LOGIN_SUCCESS, processLoginSuccess)
}
